import { render, staticRenderFns } from "./MaterialsWarehouses.vue?vue&type=template&id=624a89b8"
import script from "./MaterialsWarehouses.vue?vue&type=script&lang=js"
export * from "./MaterialsWarehouses.vue?vue&type=script&lang=js"
import style0 from "./MaterialsWarehouses.vue?vue&type=style&index=0&id=624a89b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports